import { Card, Group, Text, Title } from "@mantine/core";
import { MapItemControls } from "./MapItemControls";
import { ScopeBadge } from "./ScopeBadge";
import type { FC } from "react";
import type { MapItemProps } from "../types/props.js";

export const MapItemCondensed: FC<MapItemProps> = ({ style, version, account }) => {
  const {
    displayName,
    scope,
    description,
  } = style;

  return (
    <Card withBorder shadow="sm" radius="md" p="sm">
      <Group justify="space-between" align="center">
        <Group>
          <Title order={4}>
            {displayName}
          </Title>

          {description && (
            <Text size="sm" c="dimmed" lineClamp={1}>
              {description}
            </Text>
          )}
          <ScopeBadge scope={scope} />
        </Group>

        <MapItemControls
          account={account}
          style={style}
          version={version}
        />
      </Group>
    </Card>
  );
};
